import * as constants from './Login.constants';
import * as services from './Login.service';

import { cookieSetItem } from '@/global/cookie';

const state = {
  loginStatus: 0,
  loginMessage: '',
  loginData: 0,
  userInfo: {},
  //
  qrcodeStatus: -100,
  wechatBinding: false,
  wechatUser: {},
};

const mutations = {
  [constants.POST_LOGIN_SUCCESS](state, data) {
    state.loginStatus = data.status;
    state.loginMessage = data.message;
    state.loginData = data.data;
  },

  [constants.WECHAT_BIND_SUCCESS](state, data) {
    state.loginStatus = data.status;
    state.loginMessage = data.message;
  },

  [constants.CHECK_LOGIN_QRCODE_SUCCESS](state, data) {
    state.loginStatus = data.status;
    state.loginMessage = data.message;
  },

  [constants.SET_QRCODE_STATUS](state, data) {
    state.qrcodeStatus = data.data.qrcodeStatus;
  },

  [constants.SET_WECHAT_LOGIN_DATA](state, data) {
    if (data.data.wechatCallback) {
      const wechatCallback = data.data.wechatCallback;
      state.wechatBinding = wechatCallback.binding;
      state.wechatUser = wechatCallback.wechatUser;
    }
  },
  [constants.GET_IM_TOKEN_SUCCESS](state, data) {
    // state.isRequest = data;
    // console.log(data);
    cookieSetItem('uid', data.accId);
    cookieSetItem('sdktoken', data.token);
  },
};

const actions = {
  async postLogin({ commit }, payload) {
    const res = await services.postLogin(payload);
    commit(constants.POST_LOGIN_SUCCESS, res.data);
  },

  async getIMToken({ commit }, payload) {
    const res = await services.getIMToken(payload);
    commit(constants.GET_IM_TOKEN_SUCCESS, res.data.data);
  },

  async postLoginSms({ commit }, payload) {
    const res = await services.postLoginSms(payload);
    commit(constants.POST_LOGIN_SUCCESS, res.data);
  },

  async postLoginPasswd({ commit }, payload) {
    const res = await services.postLoginPasswd(payload);
    commit(constants.POST_LOGIN_SUCCESS, res.data);
  },

  async postSmsRegisterMobilePrecheck({ commit }, payload) {
    const res = await services.postSmsRegisterMobilePrecheck(payload);
    commit(constants.POST_LOGIN_SUCCESS, res.data);
  },

  async postSmsRegisterWechatPrecheck({ commit }, payload) {
    const res = await services.postSmsRegisterWechatPrecheck(payload);
    commit(constants.POST_LOGIN_SUCCESS, res.data);
  },

  async postLoginSmsRegisterNewUser({ commit }, payload) {
    const res = await services.postLoginSmsRegisterNewUser(payload);
    commit(constants.POST_LOGIN_SUCCESS, res.data);
  },

  async wxLogin({ commit }, payload) {
    const res = await services.wxLogin(payload);
    //alert(res.data.status);
    //alert(res.data.data);
    commit(constants.WECHAT_LOGIN_SUCCESS, res.data);
  },

  async wxLoginNewUserBind({ commit }, payload) {
    const res = await services.wxLoginNewUserBind(payload);
    commit(constants.WECHAT_BIND_SUCCESS, res.data);
  },

  async wxLoginOldUserBind({ commit }, payload) {
    const res = await services.wxLoginOldUserBind(payload);
    commit(constants.WECHAT_BIND_SUCCESS, res.data);
  },

  //
  async checkLoginQrcode({ commit }, payload) {
    const res = await services.checkLoginQrcode(payload);
    commit(constants.CHECK_LOGIN_QRCODE_SUCCESS, res.data);
    if (res.data.status === 200) {
      commit(constants.SET_QRCODE_STATUS, res.data);
      commit(constants.SET_WECHAT_LOGIN_DATA, res.data);
    }
    return res;
  },

  async checkCaptcha({}, payload) {
    const res = await services.checkCaptcha(payload);
    return res;
  },
};

const getters = {
  loginStatus: (state) => state.loginStatus,
  loginMessage: (state) => state.loginMessage,
  loginData: (state) => state.loginData,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
